export default "__VITE_ASSET__BWdpP6kz__"